import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  toInt,
} from "../util";

export const addEquityInvestmentToBusiness = ({
  businessId,
  nickname,
  investee_name,
  country,
  share_equity,
  ownership_structure,
  scope_1,
  scope_2,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    nickname: nickname,
    investee_name: investee_name,
    country: country,
    share_equity: toInt(share_equity, undefined),
    ownership_structure: ownership_structure,
    scope_1: toInt(scope_1, undefined),
    scope_2: toInt(scope_2, undefined),
    year: toInt(year, undefined),
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/equity",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage({});
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteEquityInvestment = ({
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/equity/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getEquityInvestmentList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var config = {
    method: "get",
    url: baseUrl + "/api/business/equity",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          data.leased = data.leased ? "Yes" : "No";
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateEquityInvestment = ({
  businessId,
  objectId,
  nickname,
  investee_name,
  country,
  share_equity,
  ownership_structure,
  scope_1,
  scope_2,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    nickname: nickname,
    investee_name: investee_name,
    country: country,
    share_equity: toInt(share_equity, undefined),
    ownership_structure: ownership_structure,
    scope_1: toInt(scope_1, undefined),
    scope_2: toInt(scope_2, undefined),
    year: toInt(year, undefined),
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/equity/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);

      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getEquityInvestment = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setNickname = function () {
    return;
  },
  setInvesteeName = function () {
    return;
  },
  setCountry = function () {
    return;
  },
  setShareEquity = function () {
    return;
  },
  setOwnershipStructure = function () {
    return;
  },
  setScope1 = function () {
    return;
  },
  setScope2 = function () {
    return;
  },
  setIsDataLoaded = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/equity/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);

      const gotValue = response.data.data;

      setNickname(gotValue.nickname);
      setInvesteeName(gotValue.investee_name);
      setCountry(gotValue.country);
      setShareEquity(gotValue.share_equity);
      setOwnershipStructure(gotValue.ownership_structure);
      setScope1(gotValue.scope_1);
      setScope2(gotValue.scope_2);
      setIsDataLoaded(true);
    })
    .catch(function (error) {
      console.log(error);
      setIsDataLoaded(true);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
